<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nueva área" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="program" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Nombre" prop="name">
                        <Input :autosize="{minRows: 5,maxRows: 8}" v-model="program.name" placeholder="Nombre"/>
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Agregar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                program: {
                    name: ""
                },
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Nombre es requerido', trigger: 'change' }
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + '/programs/create', { ...this.program, })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('drawer--add-program', response.data.program)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                    }
                })
            },
            clear(){
                this.program = {
                    name: ""
                }
            }
        },
        mounted(){
            window.EventBus.$on('drawer--create-program', () => {
                this.show = true
            })
        }
    }
</script>